const el = document.querySelector('#env');

export default JSON.parse(el.innerHTML);
